import styled from "styled-components";

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  padding: 0 16px 0 0;
  gap: 12px;
`;

export const FloatWrap = styled.div`
  position: absolute;
  height: calc(100vh - 68px);
  z-index: 10;
`;

export const GenAI = styled(FloatWrap)<{ isVisible?: boolean }>`
  width: 368px;
  margin: 0 12px;
  right: 0;
  display: flex;
  transform: translateX(${({ isVisible }) => (isVisible ? "0" : "100%")});
  transition: all 0.2s;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: var(--hv-surface-widget);
  border-radius: 12px;
  transition: margin-right 0.2s ease;
  padding-bottom: 20px;

  .mantine-ScrollArea-viewport > div {
    display: block !important;
  }
`;

export const Title = styled.h1`
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
`;

export const ChartList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FilterNameWrapper = styled.div<{ scrolled: boolean }>`
  display: flex;
  align-items: center;
  min-height: 52px;
  padding: 0 20px;
  border-bottom: ${({ scrolled }) =>
    scrolled ? "1px solid var(--hv-border-default)" : "1px solid transparent"};
`;

export const FilterName = styled.h1`
  font-size: 18px;
  font-weight: 600;
  color: var(---hv-text-normal-primary);
`;

export const DropDownAndListWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 20px 20px 20px;
`;

export const ChartFilterWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LocationName = styled.div``;

export const NoticeWrap = styled.div`
  width: 100%;
  height: calc(100vh - 198px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 12px;

  svg path,
  circle {
    stroke: var(--icon-emphasis);
  }
`;

export const NoticeTitile = styled.h1`
  font-size: var(--hv-fontsize-body-md);
  font-weight: var(--hv-font-weight-bold);
  color: var(--hv-text-normal-primary);
  margin-top: 12px;
  margin-bottom: 4px;
`;

export const NoticeMessage = styled.p`
  font-size: 14px;
  font-weight: var(--hv-font-weight-regular);
  color: var(--hv-text-normal-tertiary);
  white-space: pre-line;
  text-align: center;
`;
